import BigSwitch from './BigSwitch';

export default BigSwitch;
